import React from "react";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Stack } from "@mui/material";

import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./RelatedTrades.module.css";

export const LoadingRelatedTrades = () => {
  return (
    <Stack className={styles.container}>
      <Stack direction="row" alignItems="center" spacing={8} padding={2}>
        <Stack direction={"row"} spacing={2}>
          <ChevronRightIcon />
          <Text variant="body" style={{ alignContent: "center" }}>
            Last Submitted Proposals
          </Text>
          <Skeleton width={120} />
        </Stack>

        <Stack direction={"row"} spacing={1}>
          <Skeleton width={100} />
          <Text variant="body">{"/"}</Text>
          <Skeleton width={100} />
        </Stack>
      </Stack>
    </Stack>
  );
};

export const LoadingDetailsRow = () => {
  return (
    <Stack className={styles.tableContainer}>
      {new Array(1).fill(null).map((_, i) => (
        <Stack
          key={i}
          direction={"row"}
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          className={styles.tableRow}
        >
          <Text className={styles.textRow}>
            <Skeleton width={100} />
          </Text>
          <Text className={styles.textRow}>
            <Skeleton width={100} />
          </Text>
          <Text className={styles.textRow}>
            <Skeleton width={100} />
          </Text>
          <Text className={styles.textRow}>
            <Skeleton width={100} />
          </Text>
          <Text className={styles.textRow}>
            <Skeleton width={100} />
          </Text>
          <Text className={styles.textRow}>
            <Skeleton width={100} />
          </Text>
          <Text className={styles.textRow}>
            <Skeleton width={100} />
          </Text>
        </Stack>
      ))}
    </Stack>
  );
};

export const ErrorRelatedTrades = () => {
  return (
    <Stack className={styles.container}>
      <Stack direction="row" alignItems="center" spacing={8} padding={2}>
        <Text>Related trades failed to load</Text>
      </Stack>
    </Stack>
  );
};
